import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { PdfExportDataDTO } from "@main/pdf-exporting/pdf-exporting.models";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IQueryCommand } from "@features/filter";
import { IPagedData } from "@features/grid";

@Injectable()
export class PdfExportingService extends BaseDataService {
    readonly url: string = "api/pdf-export";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    public getPage(command: IQueryCommand): Promise<IPagedData<PdfExportDataDTO>> {
        return this.handle(this.http.get<IPagedData<PdfExportDataDTO>>(`${this.url}/page`,
            { params: this.constructHttpParams(command) }));
    }

    public async getExportedFile(id: string): Promise<Blob> {
        return this.handle(this.http.get(`${this.url}/file/${id}`, { responseType: "blob" }));
    }

    public async downloadExportedFile(id: string, name?: string): Promise<void> {
        const blob: Blob = await this.getExportedFile(id);
        const blobUrl: string = URL.createObjectURL(blob);
        const downloadLink: HTMLAnchorElement = document.createElement("a");

        downloadLink.style.display = "none";
        downloadLink.download = name ?? "";
        downloadLink.href = blobUrl;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();

        URL.revokeObjectURL(blobUrl);
    }

    public deleteExport(id: string): Promise<void> {
        return this.httpDelete(id);
    }

    public deleteExports(): Promise<void> {
        return this.httpDelete("cleanup");
    }
}